import { render, staticRenderFns } from "./UserGroupMembers.vue?vue&type=template&id=4798cbce&"
import script from "./UserGroupMembers.vue?vue&type=script&lang=js&"
export * from "./UserGroupMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports